export enum PageviewLogViewerName {
  TextViewer = '텍스트뷰어',
  ImageViewer = '이미지뷰어',
  TalkViewer = '톡뷰어',
  VideoViewer = '영상뷰어',
}
